// @flow

import { Card } from "@mui/material";

type Props = {

};

const Card1 = (props: Props) => {
	const {maxWidth = 480, sx = {}} = props
	return (
		<Card
			sx={{
				// background: "linear-gradient(135deg, #f3e7e9 0%, #e3eeff 100%)",
				borderRadius: 4,
				boxShadow: 3,
				background: "linear-gradient(135deg, rgba(243, 231, 233, 0.8), rgba(227, 238, 255, 0.8))", // transparent gradient
				backdropFilter: "blur(10px)", // frosted glass effect
				WebkitBackdropFilter: "blur(10px)", // for Safari
				// borderRadius: 4,
				// border: "1px solid rgba(255, 255, 255, 0.3)",
				// boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", // soft shadow
				maxWidth: maxWidth,
				width: "100%",
				textAlign: "center",
				...sx
			}}
		>
			{props.children}
		</Card>
	);
};

export default Card1